import React from "react";

function XIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13"
            height="15"
            fill="none"
            viewBox="0 0 13 15"
        >
            <path
                fill="#58616D"
                fillRule="evenodd"
                d="M12.585.232c.477.364.554 1.029.172 1.484L1.969 14.59a1.14 1.14 0 01-1.553.164 1.024 1.024 0 01-.172-1.484L11.032.396a1.14 1.14 0 011.553-.164z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#58616D"
                fillRule="evenodd"
                d="M12.585 14.769a1.14 1.14 0 01-1.554-.166L.25 1.72A1.024 1.024 0 01.423.236a1.14 1.14 0 011.553.166l10.782 12.883c.381.455.304 1.12-.173 1.484z"
                clipRule="evenodd"
            ></path>
        </svg>
    );
}

export default XIcon;
